"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.598 5.47H10.88a3.732 3.732 0 10.247 4.105h1.62l1.12-1.12 1.12 1.12 1.12-1.12 1.119 1.12h1.12l1.49-1.867-2.238-2.239zm-8.71 2.237a1 1 0 11-2 0 1 1 0 012 0z"
  }), _react.default.createElement("path", {
    d: "M7.016 13.309a3 3 0 011.675-.202l2.384.398 3.06.268c.913.08 1.68.675 2 1.502l2.833-.773a2.36 2.36 0 011.584 4.43l-6.87 3.073a1.961 1.961 0 01-1.36.089l-6.6-1.97a1 1 0 00-.56-.003l-2.939.84-.55-1.924 2.94-.84a3 3 0 011.681.01l6.585 1.966 6.857-3.066a.36.36 0 00-.241-.675l-3.573.974a2.361 2.361 0 01-1.994 1.091h-3.98v-2h3.98a.367.367 0 00.032-.732l-3.138-.275-2.46-.41a1 1 0 00-.558.067l-2.2.943a3 3 0 01-2.296.028l-1.73-.692.742-1.857 1.73.692a1 1 0 00.766-.01l2.2-.942z"
  })];
};

exports.default = _default;